import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { BaseService, EnvironmentService, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class TemplateInstanceService extends BaseService {
    entityName = 'TemplateInstance';
    serviceCode = 'admin';

    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
                this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    post(item: any): Promise<ResponseResult> {
        const url = `${this.serviceUri}/CreateTemplate`;
        return this.defaultPost(url, item);
    }

    put(id: string, item: any): Promise<ResponseResult> {
        const url = `${this.serviceUri}/UpdateTemplate/${id}`;
        return this.defaultPut(url, item);
    }

    getBookmark(templateId: number, fileInstanceId: string): Promise<ResponseResult> {
        const url = `${this.serviceUri}/GetBookmark`;
        return this.defaultPost(url, { templateId, fileInstanceId });
    }

    async exportCxExcelTemplateById(rowData) {
        const url = `${this.serviceUri}/ExportCxExcelTemplateById/${rowData.id}`;

        return this._http
            .post(url, {}, { responseType: 'blob' as 'json' })
            .pipe(catchError((err: HttpErrorResponse) => this._commonService.handleError(err, this._injector)))
            .subscribe(res => {
                this.saveAsExcelFile(res, rowData.code);
            });
    }

    async importExcelTemplate(formData) {
        const url = `${this.serviceUri}/ImportCxTemplate`;
        return this.defaultPost(url, formData);
    }

}
